//REACTIVE
import { createStore } from 'vuex'
export const store = createStore({
    state () {
        return {
            smallHeader: false,
            popupOpen: false,
            popupObject:{},
            triggerTransitionOverlay: Math.random(),
            routerNext: null,
            routerNextTo: null,
            mobileCloseToggler:'',
            didInitialSiteTransition:false,
            searchTerm:'',
            deepFilterLink: null,
            selectedFilters:[],
        }
    },
    mutations: {
        setSmallHeader (state, val) {
            state.smallHeader = val
        },
        openPopup (state, obj) {
            state.popupObject = obj
            state.popupOpen = true
        },
        closePopup (state) {
            state.popupObject = {}
            state.popupOpen = false
        },
        triggerTransitionOverlay (state) {
            state.triggerTransitionOverlay = Math.random()
        },
        routerNext(state, next) {
            state.routerNext = next
        },
        routerNextTo(state, to) {
            state.routerNextTo = to
        },
        closeMobileNav(state) {
            state.mobileCloseToggler = Math.random()
        },
        setDidInitialSiteTransition(state) {
            state.didInitialSiteTransition = true
        },
        setSearchTerm(state, val) {
            state.searchTerm = val
        },
        setDeepFilterLink(state, val) {
            state.deepFilterLink = val
        },
        filterClick(state, item) {
            if (item === 'all') {
                state.selectedFilters = []
            } else {
                const index = state.selectedFilters.findIndex(
                    (filter) => filter.slug === item.slug
                );

                if (index === -1) {
                    // If the filter is not already selected, add it
                    state.selectedFilters.push(item);
                } else {
                    // If the filter is already selected, remove it
                    state.selectedFilters.splice(index, 1);
                }
            }
        }
    }
})
export default store
